import axios from 'axios';

export {
  sendMessage
};

function sendMessage(data){
  return axios.post('api/contact', data);
}